import { ScheduledAttendanceDetails } from "../../../interfaces/Attendances.interfaces";
import { StyledScheduleItem } from "./style";
import { FaCalendar, FaUserCircle } from "react-icons/fa";
import formatarCPForCNPJ from "../../../Hooks/FormatCPFCNPJ.hook";

interface ScheduleItemProps {
    schedule: ScheduledAttendanceDetails;
};

export const ScheduleItem: React.FC<ScheduleItemProps> = ({ schedule }) => {
    const date = new Date(schedule.scheduleDate);

    const dateString = date.toLocaleDateString()
    const timeString = date.toLocaleTimeString().slice(0, 9);

    return (
        <StyledScheduleItem>
            <FaUserCircle />
            <div className="dados1">
                <span>
                    <b> {schedule.contactName} </b>
                </span>
                <span>
                    {schedule.customerName?.slice(0, 40) || "CLIENTE NÃO CADASTRADO"}
                </span>
                <span>
                    CPF/CNPJ: {" "}
                    {
                        formatarCPForCNPJ(schedule.customerCnpj || "n/d")
                    }
                </span>
            </div>
            <div className="data_agendamento">
                <div>
                    <span> {dateString} </span>
                    <span> {timeString} </span>
                </div>
                <FaCalendar />
            </div>
        </StyledScheduleItem>
    );
};